import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL, BASE_URL1 } from './Constants.js';
import { Spinner, Alert } from 'react-bootstrap';

const Edit_Stock = () => {
  const [stock, setStock] = useState({
    area: '',
    dress_type: '',
    dress_size: '',
    dress_color: '',
    quantity: '',
    gnr_number: '',
    gnr_date: '',
    gnr_image: '',
    gnr_image_file: null,
  });

  const [areas, setAreas] = useState([]);
  const [dressTypes, setDressTypes] = useState([]);
  const [dressSizes, setDressSizes] = useState([]);
  const [dressColors, setDressColors] = useState([]);
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  // Fetch user profile
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`${BASE_URL}profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => setUser(data.profile.is_uniform_access_given))
      .catch(err => console.error('Profile fetch error:', err));
  }, []);

  // Fetch dropdown options
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchOptions = async () => {
      try {
        const [areaRes, typeRes, sizeRes, colorRes] = await Promise.all([
          fetch(`${BASE_URL}areas`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_types`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_sizes`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_colors`, { headers: { Authorization: `Bearer ${token}` } }),
        ]);

        const [areaData, typeData, sizeData, colorData] = await Promise.all([
          areaRes.json(),
          typeRes.json(),
          sizeRes.json(),
          colorRes.json(),
        ]);

        setAreas(areaData.areas || []);
        setDressTypes(typeData.dressTypes || []);
        setDressSizes(sizeData.dressSizes || []);
        setDressColors(colorData.dressColors || []);
      } catch (err) {
        console.error('Dropdown fetch error:', err);
      }
    };

    fetchOptions();
  }, []);

  // Fetch stock details by ID
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`${BASE_URL}get_stock/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        const stockData = data.stock || {};
        setStock({
          area: stockData.area_id || '',
          dress_type: stockData.dress_type || '',
          dress_size: stockData.dress_size || '',
          dress_color: stockData.dress_color || '',
          quantity: stockData.quantity || '',
          gnr_date: stockData.created_at || '',
          gnr_number: stockData.gnr_number || '',
          gnr_image: data.stock.gnr_image || '',
        });
      })
      .catch(err => console.error('Stock fetch error:', err))
      .finally(() => setLoading(false));
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStock(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stock.area || !stock.dress_type || !stock.dress_size || !stock.dress_color || !stock.quantity) {
      setFormError('All fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('area_id', stock.area);
      formData.append('dress_type', stock.dress_type);
      formData.append('dress_size', stock.dress_size);
      formData.append('dress_color', stock.dress_color);
      formData.append('quantity', stock.quantity);
      formData.append('gnr_number', stock.gnr_number);
      formData.append('gnr_date', stock.gnr_date);
      if (stock.gnr_image_file) {
        formData.append('gnr_image', stock.gnr_image_file);
      }

      const response = await fetch(`${BASE_URL}update_stock/${id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();

      if (result.status) {
        navigate('/manage_stocks');
      } else {
        setFormError('Failed to update stock.');
      }
    } catch (error) {
      setFormError('Error updating stock.');
    }
  };

  const handleBackClick = () => navigate('/manage_stocks');

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  if (loading) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>;
  }

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="col-lg-6 offset-lg-3">
                <div className="card add-user-card">
                  <div className="card-header">
                    <h2>Edit Stock</h2>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      {formError && <div className="alert alert-danger">{formError}</div>}

                      <div className="form-group">
                        <label>Area</label>
                        <select className="form-control" name="area" value={stock.area} onChange={handleInputChange}>
                          <option value="">Select Area</option>
                          {areas.map(a => <option key={a.id} value={a.id}>{a.area}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Dress Type</label>
                        <select className="form-control" name="dress_type" value={stock.dress_type} onChange={handleInputChange}>
                          <option value="">Select Type</option>
                          {dressTypes.map(t => <option key={t.id} value={t.id}>{t.dress_type}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Dress Size</label>
                        <select className="form-control" name="dress_size" value={stock.dress_size} onChange={handleInputChange}>
                          <option value="">Select Size</option>
                          {dressSizes.map(s => <option key={s.id} value={s.id}>{s.dress_size}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Dress Color</label>
                        <select className="form-control" name="dress_color" value={stock.dress_color} onChange={handleInputChange}>
                          <option value="">Select Color</option>
                          {dressColors.map(c => <option key={c.id} value={c.id}>{c.dress_color}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Quantity</label>
                        <input type="number" className="form-control" name="quantity" value={stock.quantity} onChange={handleInputChange} />
                      </div>

                      <div className="form-group">
                        <label>GNR Number</label>
                        <input type="text" className="form-control" name="gnr_number" value={stock.gnr_number} onChange={handleInputChange} />
                      </div>

                      <div className="form-group">
                        <label>GNR Date</label>
                        <input type="date" className="form-control" name="gnr_date" value={stock.gnr_date} onChange={handleInputChange} />
                      </div>



                      <div className="form-group">
                        <label>Upload GNR Image</label>
                        <input
                          type="file"
                          name="gnr_image_file"
                          accept="image/*"
                          className="form-control"
                          onChange={(e) => setStock(prev => ({ ...prev, gnr_image_file: e.target.files[0] }))}
                        />
                      </div>

                      {stock.gnr_image && (
                        <div className="form-group">
                          <label>GNR Image</label>
                          <div>
                            <img
                              src={`${BASE_URL1}/uploads/gnr_images/${stock.gnr_image}`}
                              alt="GNR"
                              style={{ maxWidth: '100%', height: 'auto', border: '1px solid #ccc' }}
                            />
                          </div>
                        </div>
                      )}

                      <div className="d-flex justify-content-between">
                        <button type="submit" className="btn btn-primary">Update</button>
                        <button type="button" className="btn btn-secondary" onClick={handleBackClick}>Cancel</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Edit_Stock;
